import axios from './customAxios';

const generalesProvider = {
    obtenerListaValor: async(val) => {
        return await axios.get('/generales/ObtenerListaValor', { params: { id: val } });
    },
    obtenerLista: async() => {
        return await axios.get('/generales/ObtenerLista', {});
    },
    listar_listavalorespaginado: async(request) => {
        return await axios.post('/generales/Listar_ListaValoresPaginado', request);
    },
    registrar_actualizar_listavalor: async(body) => {
        return await axios.post('/generales/Registrar_Actualizar_ListaValor', body);
    },
    eliminar_listavalor: async(body) => {
        return await axios.post('/generales/Eliminar_ListaValor', body);
    },

    ObtenerListaValorPorSkeyCab: async(body) => {
        return await axios.post('/generales/ObtenerListaValorPorSkeyCab', body);
    },
    ListarCategoriaPaginado: async(body) => {
        return await axios.post('/generales/ListarCategoriaPaginado', body);
    },
    Registrar_Actualizar_Categoria: async(body) => {
        return await axios.post('/generales/Registrar_Actualizar_Categoria', body);
    },
    Eliminar_Categoria: async(body) => {
        return await axios.post('/generales/Eliminar_Categoria', body);
    }
};

export default generalesProvider;